<template>
	<div class="old_acc">
		<div class="ac_box1">
			<p class="ac_box1_tit" data-aos="fade-up">剑南春·天益老号</p>
			<p class="ac_box1_p1" data-aos="fade-up">1500年中国白酒古窖池</p>
			<p class="ac_box1_p2" data-aos="fade-up">
				天益老号是剑南春酒坊遗址中的一处，入选中国考古界权威的评选活动“2004年全国十大考古新发现”，并被列入全国重点文物保护
			</p>
			<p class="ac_box1_p2" data-aos="fade-up">
				单位。剑南春酒坊遗址能获得考古界的认证，意味着中国考古学掀开了重视工业文明研究的崭新篇章，也折射出剑南春自身深
			</p>
			<p class="ac_box1_p2" data-aos="fade-up">
				厚文化的积淀。时至今日，“天益老号”仍一直为剑南春酿造着琼浆玉液。
			</p>
		</div>
		<div class="ac_box2">
			<div class="ac_box2_con" data-aos="fade-up">
				<p class="gm_p1">规模宏大，业内罕见</p>
				<ul class="gm_list">
					<li class="gm_item">
						<p class="gtm_p1">长度</p>
						<div class="gtm_d1">
							<span class="gtm_p2">500</span>
							<div class="gtm_p3">
								<p>+</p>
								<p>米</p>
							</div>
						</div>
					</li>
					<li class="gm_item">
						<p class="gtm_p1">宽度</p>
						<div class="gtm_d1">
							<span class="gtm_p2">240</span>
							<div class="gtm_p3">
								<p>+</p>
								<p>米</p>
							</div>
						</div>
					</li>
					<li class="gm_item">
						<p class="gtm_p1">总面积</p>
						<div class="gtm_d1">
							<span class="gtm_p2">120,000</span>
							<div class="gtm_p3">
								<p>+</p>
								<p>平方米</p>
							</div>
						</div>
					</li>
					<li class="gm_item">
						<p class="gtm_p1">古窖池</p>
						<div class="gtm_d1">
							<span class="gtm_p2">706</span>
							<div class="gtm_p3">
								<p style="color: transparent">+</p>
								<p>口</p>
							</div>
						</div>
					</li>
				</ul>
				<div class="gm_intro">
					<p>
						剑南春酒坊遗址位于绵竹城关外西的诸葛祠、茶盘街、棋盘街和滚子坡两侧，由西北向东南呈一线分布。西北起自诸葛祠，东南抵至王麻巷口，长约500余米，宽约240余米，总面积约120，000平方米
						。从五路口至棋盘街南端王麻巷口，长约260米、宽240米的范围内，既是清代酿酒作坊区，也是现在剑南春酒厂的第一生产区。在11口剑南春“天益老号”古酒坊周围，明清遗存至今连续使用的古窖池有695口，面积达
						6万平方米，规模之巨在全行业实属罕见。
					</p>
					<br />
					<p>
						大规模的古窖池群为这一区域形成了独特的微生物环境——它是剑南春酒品质高贵的保证，更是干年酒文化传承的见证。
					</p>
				</div>
			</div>
		</div>
		<div class="ac_box3">
			<div class="ac_box3_wrap">
				<img class="hxl" src="@/images/lishi/hxz_left.png" />
				<img class="hxr" src="@/images/lishi/hxz_right.png" />
				<div class="ac_box3_con">
					<div class="box3_d1" data-aos="fade-up">
						<div class="d1_left">
							<p class="d1_left_p1">保存完整，难以比拟</p>
							<div class="d1_left_p2">
								<p>
									“天益老号”酿酒作坊是保存完整的并且仍在生产的传统酿酒作坊，被认定为全国重点文物保护单位，入围世界文化遗产预备名单。
								</p>
								<br />
								<p>
									传延下来的天益老号里的酿酒作业还是纯粹的手工操作，这里的酿酒师傅们用着古老而传统的生产工具——酒甑、云盘、鸡公车、晒笆、黄桶……其中尚有清代酿酒用水井一处，明代水缸一件，清代大曲坊木质吊牌、木匾等。发掘的遗迹现象包括晾房1座、水井1口酒窖7组共26口、炉灶5座、晾堂2座、水沟2条、池子2个盛酒坑1个以及路基、柱础和墙基等。这些保存完好的传统酿造工具有些仍然运用在现代剑南春的酿造过程中，可以说，天益老号的完整性是国内众多所谓的古窖池都难以比拟的。
								</p>
							</div>
						</div>
						<div class="d1_right">
							<img src="@/images/lishi/ls_img1.png" />
						</div>
					</div>
					<div class="box3_d2" data-aos="fade-up">
						<div class="d2_left">
							<img src="@/images/lishi/ls_img2.png" />
							<p>
								<span>【南齐纪年砖】</span>长：31cm 宽：19cm
								厚：5.5cm
							</p>
						</div>
						<div class="d2_right">
							<p class="d2_right_p1">历史悠久，生生不息</p>
							<div class="d2_right_p2">
								<p>
									1985年6月6日，天益老号出土了一块砖，考古学家称之为“南齐纪年砖”，距今已有超过1500年的历史。它对于绵竹酒坊建造历史的考证有着重要的借鉴作用，而天益老号因为岁月的沉淀，愈加显得厚重。
								</p>
								<br />
								<p>
									窖龄越长，其香越幽，其味越正，其品越高。时至今日，天益老号仍然生生不息地酿造，为剑南春出产着传世美酒，延续着千百年前的美酒传奇。剑南春酒利用1500多年来一直沿用至今的“天益老号”古老窖池群酿造，对剑南春基础酒的品质起着关键的保证作用。
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
        <div class="rd_box"><record></record></div>
	</div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.old_acc {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
	background-image: url("../../images/bgimg3.png");
	padding-bottom: 80px;
	min-width: 950px;
	.ac_box1 {
		padding: 96px 20px 616px;
		background-image: url("../../images/lishi/bmg1.png");
		background-repeat: no-repeat;
		background-size: auto 926px;
		background-position: bottom;
		border-bottom: 10px solid #fff;
		.ac_box1_tit {
			color: #c0494b;
			font-size: 36px;
			margin-bottom: 24px;
			margin-top: 40px;
		}
		.ac_box1_p1 {
			font-size: 24px;
			color: #303030;
			margin-bottom: 20px;
		}
		.ac_box1_p2 {
			text-align: center;
			color: #333;
			font-size: 16px;
			line-height: 1.7;
			max-width: 1112px;
			margin: 0 auto;
		}
	}
	.ac_box2 {
		background: url("../../images/lishi/bmg2.png") no-repeat 50%;
		background-size: cover;
		padding: 188px 0 226px;
		.ac_box2_con {
			max-width: 924px;
			margin: 0 auto;
			.gm_p1 {
				text-align: center;
				color: #fff;
				font-size: 40px;
				margin-bottom: 90px;
			}
			.gm_list {
				display: flex;
				justify-content: space-between;
				margin-bottom: 78px;
				.gm_item {
					.gtm_p1 {
						color: #fff;
						font-size: 18px;
						font-weight: 700;
						margin-bottom: 15px;
						text-align: left;
					}
					.gtm_d1 {
						color: #fff;
						font-size: 18px;
						display: flex;
						align-items: center;
						.gtm_p2 {
							color: #fff;
							font-size: 48px;
							display: inline-block;
							margin-right: 6px;
						}
						.gtm_p3 {
							color: #fff;
							font-size: 18px;
							p {
								text-align: left;
							}
						}
					}
				}
			}
			.gm_intro {
				color: #fff;
				font-size: 16px;
				line-height: 1.7;
				p {
					text-align: left;
				}
			}
		}
	}
	.ac_box3 {
		padding: 75px 20px 60px;
		width: 100%;
		overflow: hidden;
		box-sizing: border-box;
		.ac_box3_wrap {
			max-width: 1306px;
			margin: 0 auto;
			position: relative;
			.hxl {
				position: absolute;
				left: -226px;
				top: 100px;
				z-index: 1;
			}
			.hxr {
				position: absolute;
				right: -183px;
				top: 210px;
				z-index: 1;
			}
			.ac_box3_con {
				position: relative;
				z-index: 9;
				.box3_d1 {
					display: flex;
					.d1_left {
						width: 50%;
						background-color: #fff;
						padding: 42px 38px;
						box-sizing: border-box;
						.d1_left_p1 {
							color: #c0494b;
							font-size: 36px;
							text-align: center;
							margin-bottom: 20px;
						}
						.d1_left_p2 {
							color: #333;
							font-size: 16px;
							line-height: 1.7;
							p {
								text-align: left;
							}
						}
					}
					.d1_right {
						width: 50%;
						img {
							width: 100%;
							height: 100%;
						}
					}
				}
				.box3_d2 {
					display: flex;
					.d2_left {
						background-color: #dedad1;
						width: 50%;
						position: relative;
						box-sizing: border-box;
						img {
							position: absolute;
							width: 636px;
							height: 241px;
							right: -76px;
							top: 40px;
						}
						p {
							color: #887a69;
							font-size: 20px;
							position: absolute;
							width: 100%;
							left: 0;
							bottom: 24px;
							padding: 0 38px;
							span {
								display: inline-block;
								margin-right: 30px;
							}
						}
					}
					.d2_right {
						width: 50%;
						background-color: #fff;
						padding: 42px 38px 42px 80px;
						box-sizing: border-box;
						.d2_right_p1 {
							color: #c0494b;
							font-size: 36px;
							text-align: center;
							margin-bottom: 20px;
						}
						.d2_right_p2 {
							color: #333;
							font-size: 16px;
							line-height: 1.7;
							p {
								text-align: left;
							}
						}
					}
				}
			}
		}
	}
}
</style>